<template>
  <section v-if="office" class="text-sm">
    <div v-if="office.office_approval" class="rounded-full py-2 px-4 bg-red-lightest mb-2">
      <p class="text-red">The office data has been update and pending review from HQ you can still update the office details prior to approval (your change will be made live once has been reviewed from HQ)</p>
    </div>
    <div class="flex flex-wrap mb-4" @click="expanded = !expanded">
      <img class="w-32 self-start overflow-hidden mb-2 mr-8" :src="office.logo" alt="office logo">
      <div class="flex flex-col justify-center leading-tight tracking-wide">
        <p class="leading-normal"><strong>{{ office.name }}</strong></p>
        <p>{{ office.address_name_number }}</p>
        <p>{{ office.address_line2 }}</p>
        <p>{{ office.address_line3 }}</p>
        <p>{{ office.address_town }}</p>
        <p>{{ office.address_line4 }}</p>
        <p>{{ office.address_postcode }}</p>
      </div>
    </div>
    <transition name="slide">
      <div class="mb-4 leading-tight tracking-wide" v-show="expanded">

        <div class="mb-6">
          <b>Sales Email:</b>
          <p>{{ office.sales_email }}</p>
          <br />
          <b>Lettings Email:</b>
          <p>{{ office.lettings_email }}</p>
          <br />
          <b>Sales Phone:</b>
          <p>{{ office.sales_phone }}</p>
          <br />
          <b>Lettings Phone:</b>
          <p>{{ office.lettings_phone }}</p>
        </div>
        <div class="mb-6" v-if="office.website_provider">
          <b>Website Provider:</b>
          <p>{{ office.website_provider }}</p>
          <br />
          <div v-if="office.website_provider === 'other'">
            <b>Property URL:</b>
            <p><input v-model="office.website_property_url"  type="text" class="font-bold border p-2 w-5/6"></p>
            <br />
            <b>ID:</b>
            <p>{{ website_property_id }}</p>
            <br />
            <b>Additional Parameters:</b>
            <p><input v-model="office.property_url_suffix"  type="text" class="font-bold border p-2 w-5/6"></p>
            <br />
          </div>
          <b>Sample URL:</b>
          <p>{{ sampleUrl}}
          <a :href="sampleUrl" target="_blank"><button class="bg-blue hover:bg-tertiary text-white font-bold py-2 px-4 rounded ml-2">Test</button></a>
          </p>
          <br />
        </div>
        <div class="w-full mb-4" v-if="office.network_id !==7 && office.network_id !==8">
          <button @click="openCalender()"
            class="inline-block text-black no-underline bg-grey-lighter hover:bg-grey-light border hover:border-grey mb-2 px-4 py-2 text-xs uppercase tracking-wide"
          >
            Availability Calendar
          </button>
        </div>

        <div class="w-full">
          <label class="mb-2 block">Letting fees document url</label>
          <div class="flex">
            <input v-model="office.letting_fees_url" class="rounded-l input w-full" type="text" name="something" :disabled="profile_v2.type > 4" />
            <button title="Open Media Manager" @click="openMediaManager($event)" :disabled="profile_v2.type > 4" class="border px-3 rounded-r border-l-0">
              <i class="fa fa-file"></i>
            </button>
          </div>
        </div>
        <div class="mt-4">
          <b>Property Asset</b>
          <div class="flex flex-row mb-4 mt-2">
            <div class="w-1/2">
              <div class="w-full">
                <input type="checkbox" id="not_visible_to_property_asset" v-model="office.not_visible_to_property_asset">
                <label for="not_visible_to_property_asset">Opt all properties out of Property Asset Download</label>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <b>Property Comparison</b>
          <div class="flex flex-row mb-2 mt-2">
            <div class="w-1/2">
              <div class="w-full">
                <input type="checkbox" id="not_visible_to_property_comparison" v-model="office.not_visible_to_property_comparison">
                <label for="not_visible_to_property_comparison">Opt all properties out of Property Comparison Report</label>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-16 flex items-center justify-around" v-if="profile_v2.type > 2">
          <p class="text-sm tracking-normal">Not the correct Office?</p>
          <button @click="notifyAdmin" class="bg-grey-lighter hover:bg-grey-light border hover:border-grey px-4 py-2 text-xs uppercase tracking-wide">
            <i class="fas fa-envelope mr-2"></i>
            Notify Admin
          </button>
        </div>
      </div>
    </transition>

    <div class="mb-2" v-if="office.network_id !==7 && office.network_id !==8">
      <div class="flex flex-row w-full">
        <div class="w-full">
          <div class="w-full">
            <label class="mr-1 mb-2" for="qrcode">QR Code:</label>
            <div class="w-full">
              <input v-model="office.qr_code"  type="text" placeholder="https://www.domain.com/location-search" class="font-bold mb-4 border p-2 w-full" :disabled="profile_v2.type > 4">
            </div>
            <div v-if="office.qr_code" class="flex justify-center">
              <qrcode-vue :value="office.qr_code" :size="size" level="H"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-2">
        <div class="w-full mb-4 flex-row">
          <label for="Whatsapp">Whatsapp:</label>
          <div>
            <input v-model="office.whatsapp_account" type="text" placeholder="Whatsapp account" class="font-bold mb-4 border p-2 w-full mt-2" :disabled="profile_v2.type > 4">
          </div>
        </div>
    </div>
    <div class="mb-2" v-if="office.website_provider">
      <h3 class="mb-2">Website</h3>
      <div class="flex flex-row w-full">
        <div class="w-full">
          <div class="w-full">
            <label class="mr-1" for="Sample URL">Sample URL:</label>
            <div class="w-full">
              <input type="text" class="font-bold mb-4 border p-2 w-full" disabled="disabled" :value="sampleUrl">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="system.external_data.reduced_bios === true" class="mb-2">
      <h3 class="mb-2">Office intro</h3>
      <div class="flex flex-row w-full">
        <div class="w-full">
          <div class="w-full">
            <label class="mr-1" for="heading">Heading:</label>
            <div class="w-full">
              <textarea v-model="office.office_profile.office_intro_heading"  type="text" placeholder="Office introduction" class="mb-4 border p-2 w-full"></textarea>
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="body">Body:</label>
            <div class="w-full">
              <textarea v-model="office.office_profile.office_intro_body"  type="text" placeholder="" class="mb-4 border p-2 w-full"></textarea>
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="body">Job Vacancy Application Email:</label>
            <div class="w-full">
              <input type="text"  class="font-bold mb-4 border p-2 w-full" v-model="office.job_vacancy_email">
            </div>
          </div>
          <div class="w-full">
            <div class="flex mb-2">
              <img v-if="office.office_photo" :src="office.office_photo" class="object-cover h-48 w-full">
            </div>
            <div v-if="uploadPercent > 0" class="w-full mb-2">
              <div class="text-sm mb-2 text-right">
                {{ uploadPercent }}% Uploaded
              </div>
              <div class="h-2 w-full rounded border">
                <div
                  class="h-full bg-tertiary rounded anim-width"
                  :style="{
                    width: `${uploadPercent}%`
                  }"
                ></div>
              </div>
            </div>
            <div>
              <input ref="officePhoto" type="file" accept="image/*" hidden @change="uploadOfficePhoto">
              <button v-if="office.office_photo" @click="chooseOfficePhoto" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded mb-2" type="submit" >Update office photo</button>
              <button v-else @click="chooseOfficePhoto" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" >Upload office photo</button>
            </div>
          </div>
          <div class="w-full mb-2">
            <div class="flex mb-2">
              <img v-if="office.office_hero_photo" :src="office.office_hero_photo" class="object-cover h-48 w-full">
            </div>
            <div v-if="uploadPercentHero > 0" class="w-full mb-2">
              <div class="text-sm mb-2 text-right">
                {{ uploadPercentHero }}% Uploaded
              </div>
              <div class="h-2 w-full rounded border">
                <div
                  class="h-full bg-tertiary rounded anim-width"
                  :style="{
                    width: `${uploadPercentHero}%`
                  }"
                ></div>
              </div>
            </div>
            <div>
              <input ref="officePhotoHero" type="file" accept="image/*" hidden @change="uploadOfficePhotoHero">
              <button v-if="office.office_hero_photo" @click="chooseOfficePhotoHero" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" >Update branch photo(hero)</button>
              <button v-else @click="chooseOfficePhotoHero" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" >Upload branch photo(hero)</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="system.external_data.reduced_bios === true" class="mb-2">
      <h3 class="mb-2">Client Money Protection</h3>
      <div class="flex flex-row w-full">
        <div class="w-full">
          <div class="w-full">
            <label class="mr-1" for="body">Certificate Number:</label>
            <div class="w-full">
              <input type="text"  class="font-bold mb-4 border p-2 w-full" v-model="office.cmp_certificate_number">
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="body">Authenticating body:</label>
            <div class="w-full">
              <input type="text"  class="font-bold mb-4 border p-2 w-full" v-model="office.cmp_authenticating_body">
            </div>
          </div>
          <div class="w-full mb-2">
            <div v-if="uploadPercentCertificate > 0" class="w-full mb-2">
              <div class="text-sm mb-2 text-right">
                {{ uploadPercentCertificate }}% Uploaded
              </div>
              <div class="h-2 w-full rounded border">
                <div
                  class="h-full bg-tertiary rounded anim-width"
                  :style="{
                    width: `${uploadPercentCertificate}%`
                  }"
                ></div>
              </div>
            </div>
            <div>
              <input ref="officeCmpCertificate" type="file" hidden @change="uploadOfficeCmp">
              <div class="flex flex-col w-1/2" v-if="office.cmp_certificate">
                <button @click="chooseOfficePhotoCmpCertificate" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded mb-2" type="submit" >Update Certificate</button>
                <button @click="openCertificate(office.cmp_certificate)" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" >View Certificate</button>
              </div>
              <button v-else @click="chooseOfficePhotoCmpCertificate" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" >Upload Certificate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2">
      <h3 class="mb-2">Social Media</h3>
      <div class="flex flex-row w-full">
        <div class="w-full">
          <div class="w-full">
            <label class="mr-1" for="Facebook">Facebook:</label>
            <div class="w-full">
              <input v-model="office.social_media.facebook"  type="text" placeholder="https://www.facebook.com/your-page-name" class="font-bold mb-4 border p-2 w-full" :disabled="profile_v2.type > 4">
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="instagram">Instagram:</label>
            <div class="w-full">
              <input v-model="office.social_media.instagram"  type="text" placeholder="https://www.instagram.com/your-page-name" class="font-bold mb-4 border p-2 w-full" :disabled="profile_v2.type > 4">
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="youtube">Youtube:</label>
            <div class="w-full">
              <input v-model="office.social_media.youtube"  type="text" placeholder="https://www.youtube.com/your-page-name" class="font-bold mb-4 border p-2 w-full" :disabled="profile_v2.type > 4">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h3 class="mb-2">Opening Hours</h3>
      <div class="flex flex-row">
        <div class="w-1/2">
          <div class="w-full">
            <label class="mr-1" for="monday">Monday:</label>
            <div class="w-5/6">
              <input v-model="office.opening_hours.monday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="tuesday">Tuesday:</label>
            <div class="w-5/6">
              <input v-model="office.opening_hours.tuesday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="wednesday">Wednesday:</label>
            <div class="w-5/6">
              <input v-model="office.opening_hours.wednesday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
            </div>
          </div>
          <div class="w-full">
            <label class="mr-1" for="thursday">Thursday:</label>
            <div class="w-5/6">
              <input v-model="office.opening_hours.thursday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
            </div>
          </div>
        </div>
        <div class="w-1/2">
          <div>
            <label class="mr-1" for="friday">Friday:</label>
            <input v-model="office.opening_hours.friday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
          </div>
          <div>
            <label class="mr-1" for="saturday">Saturday:</label>
            <input v-model="office.opening_hours.saturday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
          </div>
          <div>
            <label class="mr-1" for="sunday">Sunday:</label>
            <input v-model="office.opening_hours.sunday" type="text" placeholder="Opening time" class="font-bold mb-4 border p-2" :disabled="profile_v2.type > 4">
          </div>
        </div>
      </div>
    </div>
    <div v-if="profile_v2.type < 5" class="w-full flex flex-row-reverse">
      <button @click="updateOffice()" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded ml-2" type="submit" :disabled="officeModified" :class="{ 'opacity-50': officeModified }">Save</button>
      <button @click="$emit('close')" class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" >Cancel</button>
    </div>
    <modal
      v-if="mediaManagerVisible"
    >
      <media-manager
        @selected="selectMedia($event)"
        @closeMediaManager="mediaManagerVisible = false"
      />
    </modal>

     <modal
      v-if="officeChangeModal"
      :scrollY="false"
      @dismissed="officeChangeModal = false"
      @leave="officeChangeModal = false"
      :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
    >
     <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <div>Viewing the Availability Calendar for <span class="font-bold">{{office.name}}</span> change the office you are administering</div>
        </div>
        <div class="flex items-center">
          <button @click="openCalenderDifferentOffice(office)" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Ok
          </button>
          <button  @click="officeChangeModal = false" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Cancel
          </button>
        </div>
      </div>
    </modal>

     <modal
      v-if="leavingModal"
      :scrollY="false"
      @dismissed="leavingModal = false"
      @leave="leavingModal = false"
      :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
    >
     <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <div>Are you sure you want to close? There are unsaved changes.</div>
        </div>
        <div class="flex items-center">
          <button @click="updateOffice()" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Save
          </button>
          <button  @click="$emit('close')" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Close
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import { v2Api, propertyLogicApi } from '@/http'
import QrcodeVue from 'qrcode.vue'
import http from 'axios'
export default {
  name: 'office',

  props: [ 'office', 'isExpanded' ],

  data () {
    return {
      mediaManagerVisible: false,
      expanded: false,
      officeChangeModal: false,
      officeModified: true,
      initial_office: null,
      approval_values: null,
      leavingModal: false,
      property_id: '',
      website_property_id: '',
      size: 150,
      uploadPercent: 0,
      uploadPercentHero: 0,
      uploadPercentCmpLogo: 0,
      uploadPercentCertificate: 0
    }
  },
  mounted () {
    this.officeLatestProperty()
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...mapState(['profile', 'profile_v2', 'selectedOffice', 'system']),
    sampleUrl: function () {
      var regex = /^(http|https|ftp):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/ // eslint-disable-line no-useless-escape
      var websiteUrl = this.office.website_provider === 'other' ? this.office.website_property_url : this.office.website
      if (!regex.test(websiteUrl)) {
        websiteUrl = 'http://' + websiteUrl
      }
      if (this.office.website_provider === 'other') {
        return websiteUrl + this.website_property_id + (this.office.property_url_suffix ? this.office.property_url_suffix : '')
      } else if (this.office.website_provider === 'tpj') {
        return websiteUrl.replace(/\/$/, '') + '/property-details/' + this.website_property_id
      } else if (this.office.website_provider === 'starberry') {
        return websiteUrl.replace(/\/$/, '') + '/' + this.website_property_id
      } else {
        return websiteUrl.replace(/\/$/, '') + '/p/' + this.website_property_id
      }
    }
  },

  created () {
    this.expanded = this.isExpanded
    this.initial_office = JSON.parse(JSON.stringify(this.office))
    this.approval_values = {
      job_vacancy_email: this.office.job_vacancy_email,
      intro_heading: this.office.office_profile.office_intro_heading,
      intro_body: this.office.office_profile.office_intro_body,
      cmp_certificate_number: this.office.cmp_certificate_number,
      cmp_authenticating_body: this.office.cmp_authenticating_body,
      opening_hours: this.opening_hours
    }
  },

  methods: {
    ...mapActions([
      'notifyAdmin',
      'updateUserOffice',
      'setSelectedOffice',
      'fetchActiveProperties',
      'nullActiveProperties',
      'displayToastNotification'
    ]),

    openMediaManager (e) {
      this.mediaManagerVisible = true
    },

    selectMedia (file) {
      this.office.letting_fees_url = file.path
      this.mediaManagerVisible = false
    },
    chooseOfficePhoto () {
      this.$refs.officePhoto.click()
    },
    chooseOfficePhotoHero () {
      this.$refs.officePhotoHero.click()
    },
    chooseOfficeCmpLogo () {
      this.$refs.officeCmpLogo.click()
    },
    chooseOfficePhotoCmpCertificate () {
      this.$refs.officeCmpCertificate.click()
    },
    async uploadOfficePhoto (e) {
      let file = e.target.files[0]

      let filePath = `branding/office/${this.office.id}`

      const extension = file.name.split('.').pop()

      let data = await this.uploadMedia(file, extension, filePath, 'officePhoto')

      propertyLogicApi.post(`/offices/${this.office.id}/upload-photo`, data)
        .then((response) => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Office photo update',
            info: `Office photo has been successfully updated`
          })
          this.uploadPercent = 0
          this.updateOffice()
        })
    },
    async uploadOfficePhotoHero (e) {
      let file = e.target.files[0]

      let filePath = `branding/office/${this.office.id}`

      const extension = file.name.split('.').pop()

      let data = await this.uploadMedia(file, extension, filePath, 'heroPhoto')

      propertyLogicApi.post(`/offices/${this.office.id}/upload-photo`, data)
        .then((response) => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Office photo update',
            info: `Office photo has been successfully updated`
          })
          this.uploadPercentHero = 0
          this.updateOffice()
        })
    },
    async uploadOfficePhotoCmp (e) {
      let file = e.target.files[0]

      let filePath = `branding/office/${this.office.id}`

      const extension = file.name.split('.').pop()

      let data = await this.uploadMedia(file, extension, filePath, 'cmpLogo')

      propertyLogicApi.post(`/offices/${this.office.id}/upload-photo`, data)
        .then((response) => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Office photo update',
            info: `Office photo has been successfully updated`
          })
          this.uploadPercentCmpLogo = 0
          this.updateOffice()
        })
    },
    async uploadOfficeCmp (e) {
      let file = e.target.files[0]

      let filePath = `branding/office/${this.office.id}`

      const extension = file.name.split('.').pop()

      let data = await this.uploadMedia(file, extension, filePath, 'certificate')

      propertyLogicApi.post(`/offices/${this.office.id}/upload-photo`, data)
        .then((response) => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Office photo update',
            info: `Office photo has been successfully updated`
          })
          this.uploadPercentCertificate = 0
          this.updateOffice()
        })
    },
    async uploadMedia (file, extension, filePath, item) {
      const response = await propertyLogicApi.post('signed-upload', {
        'disk': 's3',
        'extension': extension,
        'path': filePath,
        'visibility': 'public-read',
        'content_type': file.type
      })

      let s3File = response.data.key
      let headers = response.data.headers
      if ('Host' in headers) {
        delete headers.Host
      }

      await http.put(response.data.url, file, {
        headers: headers,
        onUploadProgress: (progressEvent) => {
          switch (item) {
            case 'heroPhoto':
              this.uploadPercentHero = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
              break
            case 'cmpLogo':
              this.uploadPercentCmpLogo = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
              break
            case 'certificate':
              this.uploadPercentCertificate = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
              break
            default:
              this.uploadPercent = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
              break
          }
        }
      })

      let data = {
        filePath: s3File,
        extension: extension,
        caption: file.name,
        item: item
      }
      return data
    },
    openCertificate (url) {
      window.open(url, '_blank').focus()
    },
    openCalender () {
      console.log(this.office.id)
      if (this.office.id === this.selectedOffice.id) {
        this.$router.push('/availability')
      }
      this.officeChangeModal = true
    },
    openCalenderDifferentOffice (val) {
      this.$store.dispatch('setSelectedOffice', val.id)
      this.$store.dispatch('fetchActiveProperties', val.id)
      this.$store.dispatch('nullActiveProperties')
      this.$router.push('/availability')
    },
    updateOffice (closeModal = true) {
      if (this.office.office_approval_config) {
        // check if approval value has changed
        this.approvalModal = true
        let updatedValues = {
          job_vacancy_email: this.office.job_vacancy_email,
          intro_heading: this.office.office_profile.office_intro_heading,
          intro_body: this.office.office_profile.office_intro_body,
          cmp_certificate_number: this.office.cmp_certificate_number,
          cmp_authenticating_body: this.office.cmp_authenticating_body,
          opening_hours: this.opening_hours
        }
        console.log(updatedValues)
        console.log(this.approval_values)
        if (!_.isEqual(this.approval_values, updatedValues)) {
          this.displayToastNotification({
            type: 'warning',
            icon: 'fa-bell',
            title: 'Office',
            info: `Some of the changes you have made have been submitted for review and approval by an administrator`
          })
        }
      }
      this.updateUserOffice(this.office)
      this.leavingModal = false
      this.officeModified = true
      this.initial_office = JSON.parse(JSON.stringify(this.office))
      this.$emit('close')
    },
    checkStatus () {
      if (!_.isEqual(this.initial_office, JSON.parse(JSON.stringify(this.office)))) {
        this.leavingModal = true
        return true
      }
      return false
    },
    officeLatestProperty () {
      v2Api
        .get('office/latest-property', {
          params: {
            website_provider: this.office.website_provider,
            office_id: this.office.id
          }
        })
        .then(response => {
          this.website_property_id = response.data.id
        })
    }
  },
  watch: {
    office: {
      handler () {
        if (!this.office) {
          return
        }
        if (!_.isEqual(this.initial_office, JSON.parse(JSON.stringify(this.office)))) {
          this.officeModified = false
          return
        }
        this.officeModified = true
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-enter-active {
  transition: all .3s ease;
}
.slide-leave-active {
  // transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transition: all .3s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-25px);
  opacity: 0;
}
</style>
